import { render, staticRenderFns } from "./CategorySalesSearch.vue?vue&type=template&id=65fe1529&"
import script from "./CategorySalesSearch.vue?vue&type=script&lang=js&"
export * from "./CategorySalesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports